import script from "./CreateEventHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateEventHeader.vue?vue&type=script&setup=true&lang=js"

import "./CreateEventHeader.vue?vue&type=style&index=0&id=1d725cf5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d725cf5"]])

export default __exports__